import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { required, zipCode } from '../../Helpers/validators';
import { normalizeZip } from '../../Helpers/normalizers';
import venuePropType from '../../Constants/venueTypes';
import AddressField from './AddressField';
import CityField from './CityField';
import ZipField from './ZipField';
import StateField from './StateField';
import CountryField from './CountryField';
import VenueNameField from './VenueNameField';
import { usStatePropType } from '../Insured/StateField';
import SpecialTaxFields from './SpecialTaxFields';

const ManualVenueAddress = ({
  usStates,
  name,
  manualVenueCity,
  manualVenueState,
  lookupTax,
  hasRegionalTax,
  taxRegions,
  isKentuckyEntity,
  lookupUtc,
  isKentuckyCity,
  setIsKentuckyCity,
  setHasLookedUpTax,
  setFormKentuckyCity,
  setIsValidManualVenueAddress,
  setManualAddress,
  updateManualCity,
}) => {
  return (
    <>
      <div className="form-group">
        <Field
          component={VenueNameField}
          validate={[required]}
          name={`${name}Name`}
          type="text"
          onChange={(e) => {
            setIsValidManualVenueAddress({ companyName: e.target.value });
            setManualAddress({ companyName: e.target.value });
          }}
        />
      </div>
      <div className="form-group">
        <Field
          component={AddressField}
          validate={[required]}
          name={`${name}Address1`}
          type="text"
          onChange={(e) => {
            setIsValidManualVenueAddress({ address1: e.target.value });
            setManualAddress({ address1: e.target.value });
          }}
        />
      </div>
      <div className="form-row">
        <Field
          component={CityField}
          validate={[required]}
          name={`${name}City`}
          type="text"
          onChange={(e) => {
            lookupTax(
              manualVenueState,
              e.target.value,
              setIsKentuckyCity,
              setHasLookedUpTax,
            );
            setIsKentuckyCity(true);
            setHasLookedUpTax(false);
            setFormKentuckyCity(e.target.value);
            setIsValidManualVenueAddress({ city: e.target.value });
            setManualAddress({ city: e.target.value });
          }}
        />
        <Field
          component={StateField}
          validate={[required]}
          name={`${name}State`}
          type="select"
          usStates={usStates}
          onChange={(value) => {
            lookupTax(
              value,
              manualVenueCity,
              setIsKentuckyCity,
              setHasLookedUpTax,
            );
            setIsValidManualVenueAddress({ state: value });
            setManualAddress({ state: value });
          }}
        />
        <Field
          component={ZipField}
          validate={[required, zipCode]}
          name={`${name}Zip`}
          type="text"
          normalize={normalizeZip}
          onChange={(e) => {
            lookupUtc(e.target.value);
            lookupTax(
              manualVenueState,
              manualVenueCity,
              setIsKentuckyCity,
              setHasLookedUpTax,
            );
            setIsValidManualVenueAddress({ zip: e.target.value });
            setManualAddress({ zip: e.target.value });
          }}
        />
      </div>
      {manualVenueState === 'KY' && !hasRegionalTax && !isKentuckyCity && (
        <div className="form-row">
          <div className="col-sm form-group form-error">
            Kentucky city not found.
          </div>
        </div>
      )}
      <div className="form-row" hidden>
        <Field
          component={CountryField}
          validate={[required]}
          name={`${name}Country`}
          type="select"
          input={{ disabled: true }}
        />
      </div>
      <SpecialTaxFields
        hasRegionalTax={hasRegionalTax}
        taxRegions={taxRegions}
        isKentuckyEntity={isKentuckyEntity}
        setFormKentuckyCity={setFormKentuckyCity}
        updateManualCity={updateManualCity}
      />
    </>
  );
};

ManualVenueAddress.propTypes = {
  usStates: usStatePropType.isRequired,
  name: PropTypes.string.isRequired,
  manualVenueCity: PropTypes.string.isRequired,
  manualVenueState: PropTypes.string.isRequired,
  lookupTax: PropTypes.func.isRequired,
  hasRegionalTax: PropTypes.bool.isRequired,
  taxRegions: PropTypes.arrayOf(venuePropType).isRequired,
  isKentuckyEntity: PropTypes.bool.isRequired,
  lookupUtc: PropTypes.func.isRequired,
  isKentuckyCity: PropTypes.bool.isRequired,
  setIsKentuckyCity: PropTypes.func.isRequired,
  setHasLookedUpTax: PropTypes.func.isRequired,
  setFormKentuckyCity: PropTypes.func.isRequired,
  setIsValidManualVenueAddress: PropTypes.func.isRequired,
  setManualAddress: PropTypes.func.isRequired,
  updateManualCity: PropTypes.func.isRequired,
};

export default ManualVenueAddress;
